import { formatINR } from '@neyara/shared';

export function Price({
  price,
  compareAtPrice,
  className = '',
}: {
  price: number;
  compareAtPrice?: number | null;
  className?: string;
}) {
  const discounted = compareAtPrice != null && compareAtPrice > price;
  return (
    <span className={`tabular inline-flex flex-wrap items-baseline gap-x-2 ${className}`}>
      <span className="font-medium">{formatINR(price)}</span>
      {discounted && (
        <s className="text-[0.85em] text-ink-soft decoration-maroon-soft/70">
          <span className="sr-only">was </span>
          {formatINR(compareAtPrice)}
        </s>
      )}
    </span>
  );
}
